// extracted by mini-css-extract-plugin
export default {"rating":"aE-z","numberOfStars":"bE-z","count":"cE-z","barGraphSpacing":"dE-z","barGraph":"eE-z"};